import { memo, useState } from 'react';

import shortformMotion from '@wconcept/wconcept-ui-renewal/public/assets/svg/shortform_motion_old.json';
import { IconPlay01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** onClick */
  onClick?: () => void;
  /** Whether to show only the simple button */
  isSimple?: boolean;
}

const ShortFormBtnOld = ({ onClick, isSimple = false }: IProps) => {
  const [$play, setPlay] = useState(false);
  const [motionEnded, setMotionEnded] = useState(false);

  if (isSimple) {
    return (
      <S.ShortFormBtnOld
        className="shortform-btn ShortFormBtnOld"
        onClick={onClick}
        label="숏폼재생"
        icon={<IconPlay01 />}
      />
    );
  }

  return (
    <>
      {motionEnded ? (
        <S.ShortFormBtnOld
          className="shortform-btn"
          onClick={onClick}
          label="숏폼재생"
          icon={<IconPlay01 />}
        />
      ) : (
        <S.ShortFormLottie
          className="shortformMotion"
          animationData={shortformMotion}
          play={$play}
          loop={false}
          onClick={onClick}
          onComplete={() => {
            setMotionEnded(true);
          }}
          onLoad={() => {
            setTimeout(() => {
              setPlay(true);
            }, 2000);
          }}
        />
      )}
    </>
  );
};

export default memo(ShortFormBtnOld);
